import mainLogo from '../../images/Savol/logosavol_h_preto.png';
import squareLogo from '../../images/Savol/logosavol_v_pequeno_preto.png';
import mainLogoWhite from '../../images/Savol/logosavol_h_branco.png';
import banner01 from '../../images/Savol/background_bannerOne_savol.jpg';
import banner02 from '../../images/Savol/savol_bg_02.webp';
import car123 from '../../images/Savol/123_pulse.jpg';
import box123 from '../../images/Savol/123_savol.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Savol',
    defaultStoreLink: 'pecas.savol.com.br',
    defaultContactEmail: 'ecommerce@savol.com.br',
    whatsappNumber: '11 93059 6459',
    CNPJ: '52.181.468/0001-23',
    CNPJname: 'Savol Veiculos Ltda',
    CNPJaddress: 'Av. Artur de Queirós, 701 - Casa Branca, Santo André - SP, 09015-510',
    launchDate: '12/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "citroen",
        "fiat",
        "kia",
        "peugeot",
        "toyota",
        "volkswagen",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "SAVOL VW CENTRO",
        "SAVOL TOYOTA",
        "SAVOL PSA",
        "SAVOL FIAT",
        "SAVOL KIA",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        // {
        //     name: 'Acessórios',
        //     img: 'tabAcessorios',
        //     products: SliderProducts.Acessorios
        // },
        {
            name: 'Luzes',
            img: 'tabLuzes',
            products: SliderProducts.Luzes
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerImg01: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: '',
    bannerBrands: '',
    aboutUsBg: banner02,


    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu veículo. Peças <mark>genuínas</mark> direto das concessionárias <mark>Savol</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'A Savol é um grupo empresarial familiar, sólido, concentrado na região do Grande ABC, São Paulo, Vale do Paraíba e Baixada Santista',
            'Fundado em 1963, portanto, há quase 60 anos atuando no ramo automobilístico e de consórcios.',
            'Atualmente o Grupo Savol agrega também, seguros, locadora de veículos, importação e forte atuação no ramo imobiliário.',
            'Orgulhosamente representamos as marcas Volkswagen, Toyota, Kia, Fiat, Peugeot e Citroen.'
        ],
        link: 'https://savol.com.br/sobre/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/gruposavol/',
        Facebook: 'https://www.facebook.com/gruposavol/',
        LinkedIn: 'https://www.linkedin.com/company/savol/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}